var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAuvik = function SvgAuvik(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.688 29.941",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M8.334 17.936a4.336 4.336 0 100 8.669 4.217 4.217 0 004.361-4.36 4.2 4.2 0 00-4.361-4.309m-.772 12a7.486 7.486 0 01-7.554-7.741 7.514 7.514 0 017.774-7.588 6.907 6.907 0 015.022 2.136v-1.652h3.58v14.383h-3.58v-1.6a8.064 8.064 0 01-5.242 2.056",
    fill: "#262161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M8.334 17.936a4.336 4.336 0 100 8.669 4.217 4.217 0 004.361-4.36 4.2 4.2 0 00-4.361-4.309zm-.772 12a7.486 7.486 0 01-7.554-7.741 7.514 7.514 0 017.774-7.588 6.907 6.907 0 015.022 2.136v-1.652h3.58v14.383h-3.58v-1.6a8.064 8.064 0 01-5.242 2.056z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M24.107 29.93a6.379 6.379 0 01-5.209-2.287c-1.154-1.533-1.154-3.813-1.154-5.04v-7.51h3.88v7.337c0 1.142 0 4.18 3.088 4.18 2.593 0 2.98-2.6 2.98-4.155v-7.362h3.88v14.381h-3.577v-1.3a4.547 4.547 0 01-3.888 1.756",
    fill: "#262161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M24.107 29.93a6.379 6.379 0 01-5.209-2.287c-1.154-1.533-1.154-3.813-1.154-5.04v-7.51h3.88v7.337c0 1.142 0 4.18 3.088 4.18 2.593 0 2.98-2.6 2.98-4.155v-7.362h3.88v14.381h-3.577v-1.3a4.547 4.547 0 01-3.888 1.756z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M39.828 29.471h-2.611l-.026-.069-5.355-14.308h3.639l3.127 9.262 2.942-9.262h3.688z",
    fill: "#262161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M39.828 29.471h-2.611l-.026-.069-5.355-14.308h3.639l3.127 9.262 2.942-9.262h3.688z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M50.013 13.481H46.19v-3.11h3.823zm0 15.99H46.19v-14.4h3.823z",
    fill: "#262161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M50.013 13.481H46.19v-3.11h3.823zm0 15.99H46.19v-14.4h3.823z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M65.672 29.471h-4.9l-5.057-6.508v6.508h-3.871V10.347h3.867v11.25l4.754-6.523h4.479l-5.575 7.056z",
    fill: "#262161"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M65.672 29.471h-4.9l-5.057-6.508v6.508h-3.871V10.347h3.867v11.25l4.754-6.523h4.479l-5.575 7.056z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M44.871 11.549a13.636 13.636 0 00-27.109 1.881h3.917a9.623 9.623 0 019.706-9.516 9.814 9.814 0 013.947.825 8.719 8.719 0 00-7.402 8.691h3.914a4.771 4.771 0 014.653-4.87 4.708 4.708 0 014.514 3.67 9.4 9.4 0 01.079 1.2h3.981a8.925 8.925 0 00-.2-1.88",
    fill: "#804096"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M44.871 11.549a13.636 13.636 0 00-27.109 1.881h3.917a9.623 9.623 0 019.706-9.516 9.814 9.814 0 013.947.825 8.719 8.719 0 00-7.402 8.691h3.914a4.771 4.771 0 014.653-4.87 4.708 4.708 0 014.514 3.67 9.4 9.4 0 01.079 1.2h3.981a8.925 8.925 0 00-.2-1.881z",
    fill: "none",
    stroke: "#743182",
    strokeWidth: 0.015
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuvik, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auvik.42b5b519.svg";
export { ForwardRef as ReactComponent };